<template>
  <div class="modal-mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <h5>{{ counterName }}</h5>
          <i class="close" @click="closeDialog"></i>
        </div>
        <div class="modal-body"></div>
        <div class="col-md-12 loading" v-if="isLoading">
          <loadingBar type="ripple" />
        </div>
        <div v-else>
          <ul>
            <li v-for="role in userRoles">
              <label style="cursor: pointer">
                <div class="icheckbox_square-grey">
                  <input type="checkbox" class="checkBox" v-model="role.isUsed" :value="role.idpRoleId" />
                </div>
                <span>{{ role.name }}</span>
              </label>
            </li>
          </ul>
          <div class="custom-footer modal-footer" style="text-align: center">
            <button class="btn btn-primary" @click="save">ثبت</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../views/profile/store/index";
import loadingBar from "../../components/loading/PdkSpinner";
var qs = require("qs");

export default {
  store,
  components: { loadingBar },
  props: { counterId: String, counterName: String },

  data() {
    return {
      showModal: false,
      userRoles: [],
      isLoading: false,
    };
  },

  mounted() {
    // this.syncUserWithIdentity();
    this.getCountrRoles();
  },

  methods: {
    async getCountrRoles() {
      this.isLoading = true;
      const data = {
        parentIdpUserId: localStorage.getItem("UserId"),
        idpUserId: this.counterId,
      };

      const res = await this.$store.dispatch(
        "getCounterRoles",
        qs.stringify(data)
      );
      this.userRoles = res.data;
      this.isLoading = false;
    },
    async save() {
      this.isLoading = true;
      const roles = [];

      this.userRoles.forEach((element) => {
        if (element.isUsed) roles.push(element.idpRoleId);
      });
      const data = {
        idpUserId: this.counterId,
        idpRoleIds: roles,
      };
      const result = await this.$store.dispatch("asignRolesToUser", data);
      if (result.status == 201) {
        // alert("عملیات  با موفقیت انجام پذیرفت");
        this.$toast.success("!عملیات  با موفقیت انجام پذیرفت", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      } else {
        // alert("خطا در انجام عملیات");
        this.$toast.error("خطا در انجام عملیات", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
      }
      this.isLoading = false;
      this.closeDialog();
    },
    async syncUserWithIdentity() {
      await this.$store.dispatch("syncUserWithIdentity");
      this.syncUsersRolesrWithIdentity();
    },
    async syncUsersRolesrWithIdentity() {
      await this.$store.dispatch("syncUsersRolesrWithIdentity");
      this.getCountrRoles();
    },

    closeDialog() {
      this.$emit("closeDialog", true);
    },
  },
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 39%);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.custom-footer {
  padding: 18px 5px 2px 5px !important;
}

.modal-container {
  width: 600px;
  margin: 0px auto;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0px 10px;
}

.modal-default-button {
  float: right;
  width: auto !important;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-btn {
  width: 50px !important;
  height: 30px !important;
  padding: 0px !important;
  font-size: 12px;
}

.attach-btn {
  text-align: cenght;
  background: #3485e2;
  padding: 0px;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
  background-color: azure;
}

.close {
  position: relative !important;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}

.disabledBtn {
  background-color: #5da2c6 !important;
}

input[type="checkbox"] {
  width: 22px;
  /*Desired width*/
  height: 22px;
  /*Desired height*/
}

ul {
  list-style-type: none;
}

.loading {
  text-align: center !important;
}
</style>
